import { useChromelessCommunicationChannel } from './useChromelessCommunicationChannel';
import { usePiPObserver } from './usePiPObserver';

/**
 * Sets up mobile native bridge communication and observers for Omega chromeless video.
 *
 * This component facilitates interaction between the web CVSDK video player and the native layer (via WebView),
 * enabling playback control and Picture-in-Picture (PiP) state syncing.
 * @param {object} props - Component properties.
 * @param {React.RefObject<HTMLDivElement>} props.containerRef - Reference to the video container element.
 * @param {boolean} props.autoplayEnabled - Flag indicating if autoplay is enabled for the video.
 * @param {(shouldMount: boolean) => void} props.onMountRequest - Callback function to be called when the component mounts.
 * @param {(shouldAutoplay: boolean) => void} props.onAutoplayRequest - Callback function to be called when an autoplay request is made.
 * @param {(shouldMutedAutoplay: boolean) => void} props.onMutedAutoplayRequest - Callback function to be called when a muted autoplay request is made.
 */
export const OmegaVideoNativeBridge = ({
  containerRef,
  autoplayEnabled,
  onMountRequest,
  onAutoplayRequest,
  onMutedAutoplayRequest,
}) => {
  useChromelessCommunicationChannel({
    autoplayEnabled,
    onMountRequest,
    onAutoplayRequest,
    onMutedAutoplayRequest,
  });
  usePiPObserver(containerRef);
  return null;
};
